import React from 'react';
import taylorImage from '../assets/taylor_lebert.jpg';

const AboutTile = ({ title, paragraphs, stats }) => {
    return (
        <div className="pt-36 pb-20 container mx-auto px-4">
            <div className="glass-panel p-12 mx-auto animate-fade-in opacity-0">
                <h1 className="text-4xl font-bold mb-4 text-center animate-slide-up opacity-0 animation-delay-100">{title}</h1>
                <div className="w-64 h-0.5 bg-gradient-to-r from-primary-blue to-[#00C6FF] mx-auto mb-8 rounded-full animate-slide-up opacity-0 animation-delay-100"></div>
                <div className="flex flex-col md:flex-row gap-12 items-center">
                    <div className="w-full md:w-1/3 animate-fade-in-up opacity-0 animation-delay-200">
                        <img 
                            src={taylorImage} 
                            alt="Taylor Lebert - Owner of Magic Man Plumbing & Heating" 
                            className="w-full aspect-square object-cover rounded-2xl shadow-lg"
                        />
                    </div>
                    <div className="w-full md:w-2/3">
                        {paragraphs.map((paragraph, index) => (
                            <p key={index} className="text-lg text-text-light mb-6 animate-fade-in-up opacity-0 animation-delay-300">
                                {paragraph}
                            </p>
                        ))}
                        <div className="grid grid-cols-2 gap-4 mt-8">
                            {stats.map((stat) => (
                                <div key={stat.id} className="glass-panel p-4 text-center animate-fade-in-up opacity-0 animation-delay-400">
                                    <span className="block text-3xl font-bold text-primary-blue">{stat.value}</span>
                                    <span className="text-sm text-text-light">{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutTile;
